// extracted by mini-css-extract-plugin
export default {"row":"LocationParametersStyles_row__Sjd4P","sizeInput":"LocationParametersStyles_sizeInput__2cuZY"};